/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, ChangeDetectionStrategy, OnInit} from '@angular/core';
import {LoadingService} from '../../shared/loading/loading-service/loading.service';

@Component({
    selector: 'app-training-materials-main-page',
    templateUrl: './training-materials-main-page.component.html',
    styleUrls: ['./training-materials-main-page.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TrainingMaterialsMainPageComponent implements OnInit {

    constructor(private loadingService: LoadingService) {}

    ngOnInit(): void {
        this.loadingService.stop();
    }
}

